import { Col, Column, Container, Gap, Gutter, Nav, Row, Stack, StackDirection, Text } from "@rebootui";
import { Link } from "react-router-dom";
import Icon from "../common/Icon";
import { siteNavLinks } from "../../data/siteNavLinks";
import logoUrl from "../../assets/images/logo.svg";


const Footer = () => {
    return (
        <footer className="footer pt-7 pb-6 bg-gray">
            <Container className="px-4">
                <Row gutter={Gutter.G5}>
                    <Column col={[Col.Col12, Col.ColSm6, Col.ColMd3]}>
                        <Stack direction={StackDirection.Column} gap={Gap.Gap3}>
                            <Link to="/" className="navbar-brand d-flex align-items-center gap-s">
                                <img src={logoUrl} alt="logo" className="logo" style={{ height: "40px" }} />
                            </Link>
                            <Text el="p" className="small text-secondary mb-0">
                                A modern React component library powered by <a target="_blank" href="https://reactufy.com/">ReactuFY</a>.
                            </Text>
                        </Stack>
                    </Column>
                    <Column col={[Col.Col12, Col.ColSm4, Col.ColMd3]}>
                        <Stack direction={StackDirection.Column} gap={Gap.Gap3} className="ps-md-5">
                            <Text className="h6 fw-bold mb-0" style={{ letterSpacing: "0.7px" }}>PRODUCT</Text>
                            <Nav className="me-auto flex-column">
                                {siteNavLinks.map((navlink) => (
                                    <Nav.Item key={navlink.url}>
                                        <Nav.Link as={Link} to={navlink.url}>
                                            {navlink.name}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        </Stack>
                    </Column>
                    <Column col={[Col.Col12, Col.ColSm6, Col.ColMd3]}>
                        <Stack direction={StackDirection.Column} gap={Gap.Gap3}>
                            <Text className="h6 fw-bold mb-0" style={{ letterSpacing: "0.7px" }}>COMMUNITY</Text>
                            <Nav className="me-auto flex-column">
                                <Nav.Item>
                                    <Nav.Link href="/">
                                        <Icon name="github" width={16} className="text-muted me-2" />
                                        <span>GitHub</span>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="/">Issues</Nav.Link>
                                    <Nav.Link href="/">Contribute</Nav.Link>
                                    <Nav.Link href="/">License</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Stack>
                    </Column>
                    <Column col={[Col.Col12, Col.ColSm6, Col.ColMd3]}>
                        <Stack direction={StackDirection.Column} gap={Gap.Gap3}>
                            <Text className="h6 fw-bold mb-0" style={{ letterSpacing: "0.7px" }}>RESOURCES</Text>
                            <Nav className="me-auto flex-column">
                                <Nav.Item>
                                    <Nav.Link href="/">Documentation</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="/">API Reference</Nav.Link>
                                    <Nav.Link href="/">Changelog</Nav.Link>
                                    <Nav.Link href="/">Blog</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Stack>
                    </Column>
                    <Column>
                        <Text className="small text-secondary mb-0 text-center">
                            &copy; {new Date().getFullYear()} RebootUI. All rights reserved.
                        </Text>
                    </Column>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
